module.exports = __webpack_public_path__ + "img/contact-light.8965247b.png";